import type { GetOrCreatePaymentRequest } from '@/core/generated/api';
import type { CreatePaymentFormValues } from './model/createPaymentSchema';

/** Собирает запрос на формирование платежа из данных формы заказа */
export const createPaymentFormToRequest = (
    values: CreatePaymentFormValues,
    orderId: string,
): GetOrCreatePaymentRequest => ({
    orderId,
    applyPromoCode: values.promoCodeNumber.trim()
        ? {
            isRemove: false,
            number: values.promoCodeNumber.trim()
        }
        : undefined,
    applyCustomService: values.hasCustomService
        ? {
            name: values.customServiceName.trim(),
            price: values.customServicePrice,
            executorReward: values.customServiceExecutorReward,
        }
        : undefined,
});
